import axios, { AxiosInstance } from 'axios';

// Resolve API base URL with safe production default
const resolveApiBase = (): string => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    return '/api';
  }
  return 'http://localhost:5001/api';
};

// Create axios instance for the public website
const api: AxiosInstance = axios.create({
  baseURL: resolveApiBase(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Utility function to get full image URL
export const getImageUrl = (imagePath: string): string => {
  if (!imagePath) return '';
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  const apiBase = resolveApiBase();

  // Ensure the image path starts with /
  const cleanImagePath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;

  // If it's an uploads path, route via the API prefix to avoid ingress issues
  if (cleanImagePath.startsWith('/uploads')) {
    return `${apiBase}${cleanImagePath}`; // e.g., /api/uploads/...
  }

  // Otherwise use same-origin without /api
  const cleanBaseURL = apiBase.replace('/api', '');
  return `${cleanBaseURL}${cleanImagePath}`;
};

export default api; 